export default "__VITE_ASSET__QLNTFfgi__"